export default `
  :root {
      /* # Color Palette */
      --wuk-primary-color: #1D3861;

      /* # Buttons */
      --wuk-button-theme-primary-background: var(--wuk-primary-color);
      --wuk-button-theme-primary-hover-background: #2972a8;
      --wuk-button-theme-secondary-background: transparent;
      --wuk-button-theme-tertiary-background: #ffffff;

      /* # Font */
      --wuk-font-family: 'Montserrat';
  }
`;
